import { useDispatch, useSelector } from "react-redux";
import { setIncident, setPost } from "services/redux/feedForm/feedForm";
import { AppDispatch, RootState } from "services/redux/store";
// import { avatar } from "utils/assets_exports/images";
import { CustomComponentProps } from "utils/types/generalTypes";

export type FeedFormTriger = CustomComponentProps & {
    openModal: React.Dispatch<React.SetStateAction<boolean>>;
    modalType: "post" | "incident";
};
const FeedFormTriger = ({
    openModal,
    modalType,
    className,
    style
}: FeedFormTriger) => {
    const { avatar } = useSelector((state: RootState) => state.account);

    const dispatch = useDispatch<AppDispatch>();
    const handleOpenModal = () => {
        if (modalType == "post") {
            dispatch(setPost());
        } else {
            dispatch(setIncident());
        }
        openModal(true);
    };
    return (
        <div
            className={`feed-post-banner card d-flex flex-j-start flex-a-center gap-20 ${className}`}
            style={style}
        >
            <div className="img-col navbar-item is-account">
                <a href="#" className="d-flex flex-a-center">
                    <img src={avatar} alt="profile picture" />
                </a>
            </div>
            <div className="txt-col" onClick={handleOpenModal}>
                <p className="modal-trigger grey-text" data-modal="post-modal">
                    Write Something....
                </p>
            </div>
        </div>
    );
};

export default FeedFormTriger;
